import { useContext } from 'react'

import { OrganizationContext } from 'components'

const useUserHasManagedLicense = () => {
  const pbx = useContext(OrganizationContext)

  return (): boolean =>
    pbx?.licensesDetails?.results?.length === 0 ||
    pbx?.licensesDetails?.results?.some((license) => !license.externallyManaged) ||
    false
}

export default useUserHasManagedLicense
